export default "__VITE_ASSET__JJnrk5Ya__"